import { RootState, SingleModalState } from '../reducers/types';

export function getModals(state: RootState) {
  return state.modals;
}

export function getModal(modalID: string) {
  return function getModalInner(
    state: RootState,
  ): SingleModalState | undefined {
    return state.modals[modalID];
  };
}

export function getDailyDataByDate(state: RootState) {
  return state.dailyDataByDate;
}

export function getTrendsViewSettingsState(state: RootState) {
  return state.trendsViewSettings;
}
